/* Recently viewed (V10): the browsing history stays in localStorage as before; the cards are the homepage's
   shoppable card, fetched from the server (sections/fp-card-render.liquid),
   so Quick shop works; the requests start once the page is idle. Products already shown elsewhere on the page are skipped; the row stays hidden when
   nothing is left. */
class FPRecentlyViewed extends HTMLElement {
  static storageKey = 'fp-recently-viewed-products-v2';

  connectedCallback() {
    this.hidden = true;
    try {
      const current = JSON.parse(this.querySelector('[data-fp-current-product]')?.textContent || '{}');
      if (!current.id || !current.url) return;

      const stored = this.readProducts();
      const maximum = Math.max(4, Number.parseInt(this.dataset.maxProducts || '6', 10));
      const previous = stored.filter((item) => String(item.id) !== String(current.id)).slice(0, maximum);
      this.writeProducts([current, ...previous].slice(0, maximum + 1));
      if (!previous.length) return;
      // fetch the cards once the page is idle (a few small section requests); an empty row's wrapper has no
      // size, so a "near the screen" watcher never fires on it
      const start = () => this.renderProducts(previous, current);
      const idle = () => ('requestIdleCallback' in window ? requestIdleCallback(start, { timeout: 2500 }) : setTimeout(start, 1200));
      if (document.readyState === 'complete') idle(); else addEventListener('load', idle, { once: true });
    } catch (error) {
      console.warn('[Fifth & Piedmont] Recently viewed history unavailable.', error);
    }
  }

  readProducts() {
    try {
      const parsed = JSON.parse(localStorage.getItem(FPRecentlyViewed.storageKey) || '[]');
      return Array.isArray(parsed) ? parsed.filter((item) => item && item.id && item.url) : [];
    } catch (_error) {
      localStorage.removeItem(FPRecentlyViewed.storageKey);
      return [];
    }
  }

  writeProducts(products) {
    try { localStorage.setItem(FPRecentlyViewed.storageKey, JSON.stringify(products)); } catch (_error) { /* private mode */ }
  }

  async fetchCard(item) {
    try {
      const url = new URL(item.url, location.origin);
      url.searchParams.set('sections', 'fp-card-render');
      const response = await fetch(url); // no Accept: application/json - that returns the product JSON instead of the section
      if (!response.ok) return null;
      const html = (await response.json())['fp-card-render'];
      if (!html) return null;
      const doc = new DOMParser().parseFromString(html, 'text/html');
      return doc.querySelector('li.v6-rail__item');
    } catch (_error) {
      return null;
    }
  }

  async renderProducts(products, current) {
    const list = this.querySelector('[data-fp-recently-viewed-results]');
    if (!list) return;
    const onPage = new Set([...document.querySelectorAll('main [data-fp-handle]')].map((el) => el.dataset.fpHandle));
    onPage.add(current.handle);
    const wanted = products.filter((item) => !item.handle || !onPage.has(item.handle));
    const cards = (await Promise.all(wanted.map((item) => this.fetchCard(item)))).filter(Boolean)
      .filter((li) => { const h = li.querySelector('[data-fp-handle]')?.dataset.fpHandle; if (!h || onPage.has(h)) return false; onPage.add(h); return true; });
    if (!cards.length) return;
    list.replaceChildren(...cards.map((li) => document.importNode(li, true)));
    this.hidden = false;
    this.querySelector('fp-v6-rail')?.update?.();
    window.fpMotion?.scan(this);
  }
}

if (!customElements.get('fp-recently-viewed')) {
  customElements.define('fp-recently-viewed', FPRecentlyViewed);
}
